import com.github.chosamuel.kishibe.application.Application
import com.github.chosamuel.kishibe.application.getHeight
import com.github.chosamuel.kishibe.application.getWidth
import com.github.chosamuel.kishibe.math.Vector2
import com.github.chosamuel.matterjs.body.Body
import com.github.chosamuel.matterjs.constraint.Constraint
import com.github.chosamuel.matterjs.core.Matter
import com.github.chosamuel.matterjs.jsObject

fun Application.createBeam():Rect = Rect(
    Vector2(getWidth()*0.5,getHeight()*0.15),
    getWidth()*0.6,
    40.0,
    jsObject {
        density = 1.5
        //density = (getWidth()*0.618) * 40.0  * 0.001
    }
)

fun Application.createBeamConstraint(beam: Body): Constraint =
    Matter.Constraint.create(jsObject {
        pointA = jsObject {
            x = getWidth()*0.5
            y = 0.0
        }
        bodyB = beam
        pointB = jsObject {
            x = 0.0
            y = -10.0
        }
        stiffness = 0.0
    })